import "./DisplayUnits.css";
import React, { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import { openModal } from "../../../redux/modal/modalActions";
import { useDispatch } from "react-redux";
import { getAllUnits } from "../../../apis/itemsApis/getAllUnits";
import ResponseModal from "../../../components/common/modal/responseModal/ResponseModal";

function DisplayUnits() {
  const dispatch = useDispatch();
  const [UnitsData, setUnitsData] = useState([]);

  useEffect(() => {
    const getUnits = async () => {
      try {
        const allUnitsRes = await getAllUnits();
        if (allUnitsRes.error_code === 2 || allUnitsRes.error_code === 3) {
          dispatch(
            openModal(
              <ResponseModal text={allUnitsRes.error_message} isError={true} />
            )
          );
        } else {
          setUnitsData(allUnitsRes.res.data);
        }
      } catch (error) {
        console.error("Error fetching Units:", error);
      }
    };
    getUnits();
  }, [dispatch]);

  const tableHeaders = [
    {
      key: "id",
      name: "ID",
    },
    {
      key: "name",
      name: "Name",
    },
  ];

  return (
    <>
      <strong className="strong-margin">Units List : </strong>
      <div className="table-main-container-displayUnits">
        <Table tableHeight={"350px"} headers={tableHeaders} rows={UnitsData} />
      </div>
    </>
  );
}

export default DisplayUnits;
